import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromApp from "../../../../store/app.reducer";
import * as _ from "lodash";
import { auditTime, distinctUntilChanged, Subscription } from "rxjs";

@Component({
  selector: "app-quantity-options",
  templateUrl: "./quantity-options.component.html",
  styleUrls: ["./quantity-options.component.scss"],
})
export class QuantityOptionsComponent implements OnInit, OnDestroy {
  @Input() store_info;
  @Input() cart;
  @Input() selectedPaymentMethodID;
  @Input() orderPickup: boolean;
  @Input() dineIn: boolean;
  @Input() catalogMode: boolean;
  @Input() uposMoUser: boolean;

  public storeInfoClone;
  public selectedLang: any;
  public preorderActive: boolean = false;

  private selectedPreorderDate;
  private subscription: Subscription;
  private subscription2: Subscription;

  constructor(private store: Store<fromApp.AppState>) {}

  ngOnInit() {
    //  console.log("quantity options dine in", this.dineIn);
    this.subscription = this.store
      .select("groupApp")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (state && !_.isEqual(this.selectedLang, state.selectedLangugage)) {
          this.selectedLang = _.cloneDeep(state.selectedLangugage);
          if (!this.selectedLang) {
            this.selectedLang = "el";
          }
          // console.log("selected lang for cart custom", this.selectedLang);
        }
      });
    if (this.store_info && this.store_info.cartCustomOptions) {
      this.store_info.cartCustomOptions = _.cloneDeep(
        _.orderBy(
          this.store_info.cartCustomOptions,
          (item) => (item.position ? item.position : item.title),
          ["asc"]
        )
      );
    }

    this.subscription2 = this.store
      .select("deliveryMethodAddress")
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (
          state &&
          !_.isEqual(this.selectedPreorderDate, state.selectedPreorderDate)
        ) {
          this.selectedPreorderDate = _.cloneDeep(state.selectedPreorderDate);
          this.preorderActive = false;
          if (
            this.selectedPreorderDate &&
            this.selectedPreorderDate.date &&
            this.selectedPreorderDate.hour
          ) {
            this.preorderActive = true;
          }
          console.log("selected lang for cart custom", this.selectedLang);
        }
      });
  }

  trackTimestamp(index, option) {
    return option.timestamp;
  }
  selectCustomOption(option) {}

  isOfflinePaymentMethod(paymentMethodId: string) {
    return (
      paymentMethodId === "cash" ||
      paymentMethodId === "mobilePOS" ||
      paymentMethodId === "pre_cash" ||
      paymentMethodId === "pre_mobilePOS"
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
